/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { SearchRequest } from './search-request.js';


export let MDSearchOptions = function() {

	/**
	 *
	 * @param {Object} searchRequestState 		object literal, as returned from SearchRequest::getState()
	 * @returns {Object}						hash map of key to { config: Object, value: String|Array }
	 * 											where key is meta_id+':'+type
	 */
	function createOptionsByKeyMap( searchRequestState ) {
		let optionsByKeyMap = {};
		for( let oi=0; oi<searchRequestState.options.length; ++oi ) {
			const optionObj = searchRequestState.options[oi];
			const optKey = SearchRequest.createOptionKey(optionObj.config);
			optionsByKeyMap[optKey] = optionObj;
		}
		return optionsByKeyMap;
	}

	/**
	 *
	 * @param {Object} mjMFWCfg		 			object literal, as returned from .mjMetaFilterWidget('config')
	 * @param {Object} optionsByKeyMap 			hash map, as returned from createOptionsByKeyMap()
	 * @returns {Object|null}					null or new options object for assignment to optionsByKeyMap[key]
	 */
	function tryConvertOptionsValue( mjMFWCfg, optionsByKeyMap ) {
		if( mjMFWCfg.type==='auto_list' ) {

			// auto_set => auto_list
			let tryKey = SearchRequest.createOptionKey(mjMFWCfg.meta_id,'auto_set');
			if( optionsByKeyMap.hasOwnProperty(tryKey) ) {
				// auto_set: value is [ string, ... ]

				// -> use first value only!
				const autoSetOptionStrVal = optionsByKeyMap[tryKey].value[0] ?? null;
				if( autoSetOptionStrVal!==null ) {
					return {
						config: {
							meta_id: mjMFWCfg.meta_id,
							meta_type: mjMFWCfg.meta_type,
							type: mjMFWCfg.type,
						},
						value: JSON.stringify([['e',autoSetOptionStrVal]]),
					};
				}
			}

			// auto3_set => auto_list
			tryKey = SearchRequest.createOptionKey(mjMFWCfg.meta_id,'auto3_set');
			if( optionsByKeyMap.hasOwnProperty(tryKey) ) {
				// auto3_set: value is [ (json-encoded [ ['e',string], ... ]), ... ]   - e.g. [ '[["e","Fanta"]]', '[["e","Sprite"]]' ]

				// -> use first value only!
				const auto3SetOptionStrVal = fixFuOp( optionsByKeyMap[tryKey].value[0] ?? null );
				if( auto3SetOptionStrVal!==null ) {
					return {
						config: {
							meta_id: mjMFWCfg.meta_id,
							meta_type: mjMFWCfg.meta_type,
							type: mjMFWCfg.type,
						},
						value: JSON.stringify([['e',auto3SetOptionStrVal]]),
					};
				}
			}

		} else if( mjMFWCfg.type==='auto_set' ) {

			// auto_list => auto_set
			const tryKey = SearchRequest.createOptionKey(mjMFWCfg.meta_id,'auto_list');
			if( optionsByKeyMap.hasOwnProperty(tryKey) ) {
				// auto_list: value is json-encoded [ ['e',string], ... ]   - e.g. '[["e","Fanta"]]'

				// contains exactly one "equals" condition, as in e.g. '[["e","Fanta"]]'
				const autoListOptionStrVal = fixFuOp( optionsByKeyMap[tryKey].value ?? null );
				if( autoListOptionStrVal!==null ) {
					return {
						config: {
							meta_id: mjMFWCfg.meta_id,
							meta_type: mjMFWCfg.meta_type,
							type: mjMFWCfg.type,
						},
						value: [ autoListOptionStrVal ],
					};
				}

			}

		}


		// TODO: provide more conversions
		// if( mjMFWCfg.type==='list' || mjMFWCfg.type==='val_list' || mjMFWCfg.type==='auto_list' || mjMFWCfg.type==='auto2_list' || mjMFWCfg.type==='auto3_set' ) {
		// } else if( ( mjMFWCfg.type==='set' || mjMFWCfg.type==='val_set' || mjMFWCfg.type==='auto_set' || mjMFWCfg.type==='auto2_set' ) && mjMFWCfg.config.op==='eo' ) {
		// }

		return null;
	}


	function fixFuOp( inputValue ) {
		let optOpVal = inputValue ?? null;
		if( typeof optOpVal === 'string' ) {
			optOpVal = JSON.parse(optOpVal);
		}
		if( Array.isArray(optOpVal) && optOpVal.length===1 ) {
			if( Array.isArray(optOpVal[0]) && optOpVal[0].length===2 && optOpVal[0][0]==='e' ) {
				// contains exactly one "equals" condition, as in e.g. '[["e","Fanta"]]'
				const optStrVal = optOpVal[0][1];
				return optStrVal;
			}
		}
		return null;
	}

	return {
		createOptionsByKeyMap,
		tryConvertOptionsValue,

	};
}(); // namespace MDSearchOptions
